import { render, staticRenderFns } from "./LiveAssignmentOrderItem.vue?vue&type=template&id=6d570cc1&scoped=true"
import script from "./LiveAssignmentOrderItem.vue?vue&type=script&lang=js"
export * from "./LiveAssignmentOrderItem.vue?vue&type=script&lang=js"
import style0 from "./LiveAssignmentOrderItem.vue?vue&type=style&index=0&id=6d570cc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d570cc1",
  null
  
)

export default component.exports